const PageTemplateType = require('constants/PageTemplateType');


const TemplatesToUrlMapping = [{
    template: PageTemplateType.ProductPage,
    urls: [{
        isSpa: true,
        ulr: '/product/'
    }]
}];

module.exports = { TemplatesToUrlMapping };
